import axios from 'axios';
import { Auction } from '../types/auction';
import {
  AddBidderRequest,
  CreateAuctionRequest,
  GetAuctionListRequest,
  UpdateAuctionRequest,
} from '../types/request/auction';
import { PaginatedResponse } from '../utils/api';

const Endpoint = {
  BASE: '/auction',
  CREATE: '/',
  LIST: '/list',
  GET_BY_ID: '/{id}',
  ADD_BIDDER: '/bidder/addAuctions',
  PUBLISH_AUCTION: '/publish/:id',
  UPDATE_AUCTION: '/',
};
const BASE_URL = Endpoint.BASE;

export class AuctionService {
  static async createAuction(request: Partial<CreateAuctionRequest>) {
    const endpoint = BASE_URL + Endpoint.CREATE;
    const response = await axios.post(endpoint, request);
    return response.data;
  }

  static async getAuctionList(
    request: Partial<GetAuctionListRequest>
  ): Promise<PaginatedResponse<Auction>> {
    const endpoint = BASE_URL + Endpoint.LIST;
    const response = await axios.get(endpoint, { params: request });
    return response.data;
  }
  static async getAuctionById(
    auctionId: string,
    includePossessionDetails: boolean
  ): Promise<Auction> {
    const endpoint = BASE_URL + Endpoint.GET_BY_ID.replace('{id}', auctionId);
    const response = await axios.get(endpoint, {
      params: { includePossessionDetails: includePossessionDetails },
    });
    return response.data;
  }
  static async addBidders(request: Partial<AddBidderRequest>) {
    const endpoint = BASE_URL + Endpoint.ADD_BIDDER;
    const response = await axios.put(endpoint, request);
    return response.data;
  }

  static async publishAuction(id: string) {
    const endpoint = BASE_URL + Endpoint.PUBLISH_AUCTION.replace(':id', id);
    const response = await axios.post(endpoint);
    return response.data;
  }

  static async updateAuction(request: Partial<UpdateAuctionRequest>) {
    const endpoint = BASE_URL + Endpoint.UPDATE_AUCTION;
    const response = await axios.put(endpoint, request);
    return response.data;
  }
}
